import { useSelector } from 'react-redux';
import {
    selectSelectedFinancialYear,
    selectFinancialYearConfig,
} from '../redux/slices/financialYearSlice';

export const useFinancialYear = () => {
    const selected = useSelector(selectSelectedFinancialYear);
    const config = useSelector(selectFinancialYearConfig);
    return selected || config?.currentFinancialYear || '';
};

export default useFinancialYear;
